import { Add } from '@mui/icons-material'
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  styled,
} from '@mui/material'
import { CenteringBox } from 'components/CenteringBox'
import { useCallback, useState } from 'react'
import { Controller, useFieldArray, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { ITenderProtocolData } from 'types/final-protocol'
import { AddTechnicalEvaReusultForm } from '../subforms/add-technical-eva-result-form'

const StyledTableCell = styled(TableCell)(() => ({
  padding: 0,
  width: '100%',

  '& .MuiInputBase-root.MuiOutlinedInput-root': {
    borderRadius: 0,
  },

  '& .MuiInputBase-root.MuiOutlinedInput-root.Mui-disabled': {
    background: 'rgba(128,128,128, 0.1)',
  },
}))

type Props = {
  protocolData: ITenderProtocolData
}

export const TechnicalEvaluationResultsTable = ({ protocolData }: Props) => {
  const [technicalEvaResultForm, setTechnicalEvaResultForm] = useState(false)
  const { t } = useTranslation()
  const { control } = useFormContext()

  const { fields, append } = useFieldArray({
    control,
    name: `technicalAssessments`,
  })

  const handleFormClose = useCallback(() => {
    setTechnicalEvaResultForm(false)
  }, [])

  const handleAddClick = useCallback(() => {
    setTechnicalEvaResultForm(true)
  }, [])

  const handleFormSubmit = useCallback((values: any) => {
    append(values)
  }, [])

  return (
    <>
      {technicalEvaResultForm && (
        <AddTechnicalEvaReusultForm
          handleClose={handleFormClose}
          onAdd={handleFormSubmit}
        />
      )}
      <TableContainer>
        <Table
          sx={{
            tableLayout: 'fixed',
            background: '#FFF',
            '& td, th': {
              border: '1px solid #ccc',
            },
          }}
        >
          <TableHead>
            <TableRow>
              <TableCell>{t('ordinal')}</TableCell>
              <TableCell>{t('supplier-name')}</TableCell>
              <TableCell>{t('result')}</TableCell>
              <TableCell>{t('note')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {fields.map((technicalEva, index) => {
              return (
                <TableRow key={index}>
                  <TableCell>{index + 1}</TableCell>
                  <StyledTableCell>
                    <Controller
                      name={`technicalAssessments.${index}.orgName`}
                      control={control}
                      render={({ field }) => (
                        <TextField {...field} fullWidth variant="outlined" />
                      )}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <Controller
                      name={`technicalAssessments.${index}.result`}
                      control={control}
                      render={({ field }) => (
                        <TextField {...field} fullWidth variant="outlined" />
                      )}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <Controller
                      name={`technicalAssessments.${index}.note`}
                      control={control}
                      render={({ field }) => (
                        <TextField {...field} fullWidth variant="outlined" />
                      )}
                    />
                  </StyledTableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <CenteringBox my={2}>
        <Button
          color="primary"
          variant="contained"
          style={{ color: '#fff', backgroundColor: 'rgb(3, 34, 76)' }}
          onClick={handleAddClick}
        >
          <Add />
        </Button>
      </CenteringBox>
    </>
  )
}
